import { useEffect, useState } from 'react'
import Main from './Main'
import LeftSide from './LeftSide'
import { LayoutThree } from '../../Layout/CommonStyle'
import { RootState, useAppDispatch, useAppSelector } from '../../../store'
import { asyncGetFriends } from '../../../store/mainSlice'
import { FriendToUser } from '../../../models/FriendToUser'
import { useParams } from 'react-router-dom'
import RecentJobs from '../../Common/RecentJobs'

function MenteeFriend() {
  const { id } = useParams<{ id: string }>()
  const friends = useAppSelector((state: RootState) => state.main.friends)
  const dispatch = useAppDispatch()
  const me = useAppSelector((state: RootState) => state.user.me)

  const [friend, setFriend] = useState<FriendToUser | undefined>(undefined)

  useEffect(() => {
    loadFriends()
    // if (!friends || friends.length == 0) {
    //   loadFriends()
    // }
  }, [])

  useEffect(() => {
    if (friends && friends.length > 0) {
      let numId = -1
      if (id !== undefined) {
        try {
          numId = parseInt(id)
        } catch (e) {}
      }

      if (!id) {
        setFriend(friends[0])
      } else {
        setFriend(friends.find((f) => f.friend.id === numId))
      }
    }
  }, [friends, id])

  const loadFriends = async () => {
    await dispatch(asyncGetFriends(me.id))
  }

  return (
    <LayoutThree>
      <Main friend={friend} />
      <LeftSide friends={friends} setFriend={setFriend} friend={friend} />
      <RecentJobs />
    </LayoutThree>
  )
}

export default MenteeFriend
